export default {
  title: 'Ottieni la migliore esperienza sulla nostra app mobile',
  description: 'Risparmia tempo, accumula premi, ricevi notifiche su offerte e altro ancora',
  buttons: {
    download: "Apri l'app {{name}}",
  },
};
